import { CalendarDays, Clock, Edit3, Trash2, ArrowRight, AlertCircle } from 'lucide-react';
import React, { useState } from 'react'
import useAuth from '../../hooks/useAuth';
import { authApi } from '../../services/api/api';
import { toast, ToastContainer } from 'react-toastify';
import { Dialog, DialogActions, Zoom } from '@mui/material';

export default function ReleasePublication() {
    const { user, setUser } = useAuth()
    const api = authApi()
    const [openCancelDialog, setOpenCancelDialog] = useState(false);

    // Estados para os inputs
    const [start, setStart] = useState(user?.start ?? '');
    const [end, setEnd] = useState(user?.end ?? '');

    // Função para formatar a exibição da data (DD/MM/AAAA)
    const formatDate = (dateStr: string) => {
        if (!dateStr) return "--/--/----";

        // O segredo está aqui: trocamos o "-" por "/" para o JS não tratar como UTC puro
        // ou adicionamos o horário de meio-dia para garantir que o fuso não mude o dia.
        const [year, month, day] = dateStr.split('-');
        return `${day}/${month}/${year}`;
    };

    async function handlefreePosts() {

        if (!start || !end) {
            toast.error('Preencha as datas!');
            return;
        }

        try {
            const payload = {
                start: String(start),
                end: String(end)
            };


            const response = await api.liberarPosts(payload);

            console.log("Resposta da API recebida:", response);

            if (response?.id || response?.status === 200 || response === 200) {
                toast.success('Cronograma atualizado!', { theme: 'dark' });
                if (user && setUser) {
                    setUser({ ...user, start, end });
                }
            }
        } catch (error) {
            console.error("Erro no envio:", error);
        }
    }
    async function confirmCancelEvent() {
        try {
            const response = await api.liberarPosts({ start: '', end: '' });

            if (response?.id || response?.status === 200 || response === 200) {
                toast.info('Cronograma removido com sucesso.', { theme: 'dark' });

                // Limpa os estados locais e globais
                setStart('');
                setEnd('');
                if (user && setUser) {
                    setUser({ ...user, start: '', end: '' });
                }
            }
            setOpenCancelDialog(false); // Fecha o modal
        } catch (error) {
            toast.error('Erro ao cancelar evento.');
        }
    }

    return (
        <div className=" animate-in fade-in duration-500">
            <div className="bg-white dark:bg-[#2d3d5780] rounded-[32px] p-8 border border-gray-100 dark:border-white/5 shadow-sm">

                {/* HEADER COM TÍTULO E DATAS ATUAIS EM TEXTO */}
                <div className="mb-6 flex-col lg:flex-row flex justify-between lg:items-center ">
                    <div className="flex items-center gap-4 mb-3">
                        <div className="bg-blue-50 dark:bg-white/5 dark:text-white p-4 rounded-2xl text-blue4">
                            <CalendarDays size={20} />
                        </div>
                        <div>
                            <h3 className="text-lg font-bold text-slate-800 dark:text-white leading-none">Liberar Publicações</h3>
                            <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">Liberação de data para posts.</p>
                        </div>
                    </div>

                    {/* CONTROLE VISUAL: DATAS ATUAIS ESCRITAS */}
                    <div className="flex items-center gap-4 justify-between flex-col md:flex-row">
                        {user?.start ? (
                            <div className="flex items-center gap-3 px-4 py-2 bg-slate-50 dark:bg-white/5 rounded-2xl border border-gray-100 dark:border-white/5">
                                <div className="flex items-center gap-2">
                                    <span className="text-[9px] font-bold uppercase text-slate-400 tracking-tighter">Início:</span>
                                    <span className="text-xs font-bold text-slate-700 dark:text-slate-300">{formatDate(user.start)}</span>
                                </div>
                                <ArrowRight size={12} className="text-slate-300" />
                                <div className="flex items-center gap-2">
                                    <span className="text-[9px] font-bold uppercase text-slate-400 tracking-tighter">Fim:</span>
                                    <span className="text-xs font-bold text-red-500">{formatDate(user.end)}</span>
                                </div>

                            </div>

                        ) : (
                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest bg-slate-50 dark:bg-white/5 px-4 py-2 rounded-full">
                                ⚪ Nenhum cronograma definido
                            </span>
                        )}
                        {user?.start ? (<div className='flex items-center gap-2 text-green-700 bg-green-50 p-2 rounded-full border border-green-200' >
                            <div className="ml-2 w-2 h-2 rounded-full bg-emerald-700 animate-pulse" title="Evento Ativo" />
                            <span className='text-xs'>Publicações abertas</span>
                        </div>) : ""}

                    </div>

                </div>

                {/* INPUTS PARA ALTERAÇÃO */}
                {/* GRID DE CONFIGURAÇÃO - Ajustado para não esticar demais */}
                <div className="pt-8 border-t border-gray-100 dark:border-white/5 flex flex-col lg:flex-row lg:items-end gap-6">

                    {/* Inputs - Ocupam o espaço disponível mas com limite */}
                    <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="space-y-2">
                            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-2 italic">Abertura</label>
                            <div className="relative">
                                <Clock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                                <input
                                    type="date"
                                    value={start}
                                    onChange={(e) => setStart(e.target.value)}
                                    className="w-full pl-10 pr-4 py-3 rounded-xl bg-gray-50 dark:bg-white/10 border border-gray-100 dark:border-white/5 dark:text-white focus:ring-2 focus:ring-blue3 outline-none text-sm transition-all"
                                />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <label className="text-[10px] font-black uppercase tracking-widest text-slate-400 ml-2 italic">Fechamento</label>
                            <div className="relative">
                                <Clock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                                <input
                                    type="date"
                                    value={end}
                                    onChange={(e) => setEnd(e.target.value)}
                                    className="w-full pl-10 pr-4 py-3 rounded-xl bg-gray-50 dark:bg-white/10 border border-gray-100 dark:border-white/5 dark:text-white focus:ring-2 focus:ring-blue3 outline-none text-sm transition-all"
                                />
                            </div>
                        </div>
                    </div>

                    {/* BOTÕES - Em telas grandes ficam ao lado, com tamanho fixo */}
                    <div className="flex flex-row gap-3 lg:mb-0.5">
                        <button
                            className="w-full px-6 py-3.5 bg-blue3 hover:bg-blue4 text-white font-bold rounded-xl shadow shadow-blue-500/20 transition-all flex items-center justify-center gap-2 uppercase text-[10px] tracking-widest active:scale-95 whitespace-nowrap"
                            onClick={handlefreePosts}
                        >
                            Salvar Cronograma
                        </button>
                        {user?.start ? (<button
                            className="p-3.5 bg-slate-50 dark:bg-white/5 text-slate-400 hover:text-red-500 font-bold rounded-xl transition-all flex items-center justify-center border border-gray-100 dark:border-white/5"
                            onClick={() => setOpenCancelDialog(true)}
                            title="Cancelar Evento"
                        >
                            <Trash2 size={16} />
                        </button>) : ""}

                    </div>
                </div>



                <div className="mt-8 p-4 bg-amber-50 dark:bg-amber-900/50 border border-amber-100 dark:border-amber-900/20 rounded-2xl">
                    <p className="text-[10px] text-amber-700 dark:text-amber-500 leading-relaxed font-bold uppercase tracking-tight">
                        Nota: O sistema bloqueia automaticamente novas postagens fora deste período.
                    </p>
                </div>
            </div>
            <ToastContainer />
            <Dialog
                open={openCancelDialog}
                onClose={() => setOpenCancelDialog(false)}
                TransitionComponent={Zoom}
                PaperProps={{
                    style: {
                        borderRadius: '24px',
                        padding: '16px',
                        backgroundColor: '#ffffff',
                    },
                }}
            >
                <div className="flex flex-col items-center text-center p-4">
                    <div className="bg-red-50 p-4 rounded-full text-red-500 mb-4">
                        <AlertCircle size={40} />
                    </div>
                    <h3 className="text-xl font-black text-slate-800 uppercase tracking-tight">
                        Suspender Fórum?
                    </h3>
                    <p className="text-sm text-slate-500 mt-2">
                        Ao confirmar, o período de postagens será encerrado e nenhum aluno poderá enviar novos trabalhos até que uma nova data seja definida.
                    </p>
                </div>

                <DialogActions className="flex gap-3 p-4">
                    <button
                        onClick={() => setOpenCancelDialog(false)}
                        className="flex-1 h-12 rounded-xl text-xs font-bold uppercase tracking-widest text-slate-400 hover:bg-slate-100 transition-all"
                    >
                        Voltar
                    </button>
                    <button
                        onClick={confirmCancelEvent}
                        className="flex-[2] h-12 bg-red-500 hover:bg-red-600 text-white font-bold rounded-xl shadow-lg shadow-red-500/20 uppercase tracking-widest text-[10px] transition-all active:scale-[0.98]"
                    >
                        Sim, Encerrar
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
}